import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { approveLedger, deleteLedger, downloadExcel, downloadPDF, generateEInvoice, getPendingPaymentLedgerList, removeCreditNoteItemWiseLedgers, removedPaymentTypeLedgers, updateNarration, viewCNDNInvoice, generateInvoice } from '@/api/ledgers';
import Pagination from '@/components/Pagination/index.vue';
import { getDealerById, searchDealers } from '@/api/dealers';
import { getQuery } from '@/utils';
import Inr from '@/components/Inr/index.vue';
import { getAgentsBranchWise } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import moment from 'moment';
import { getBranches } from '@/api/locations/branches';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isExcludedToAccess, isPaymentManager, isSuperAdmin } from '@/common';
import * as XLSX from 'xlsx';
import { getAccountManagers } from '@/api/admins';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.BASE_URL = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.dealerList = [];
    this.agentList = [];
    this.listLoading = false;
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.openingBalance = 0;
    this.closingBalance = 0;
    this.isAgent = false;
    this.loggedInAdmin = null;
    this.isReadOnly = false;
    this.isAccountManager = false;
    this.downloadLoading = false;
    this.assignedBranches = [] || null;
    this.isSuperAdmin = false;
    this.isPaymentManager = false;
    this.selectedLedgerIds = [];
    this.dialogFormVisible = false;
    this.selectedRow = null;
    this.form = {
      comments: ''
    };
    this.accountManagers = {};
    this.accountManagerOptions = [];
    this.listQuery = {
      page: 1,
      limit: 50,
      dealerId: undefined,
      agentId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      paymentType: 'Payment',
      applyBranchIdFilter: true,
      createdTimestamp: undefined,
      createdBy: undefined,
      approvalStatus: 'Pending',
      sort: 'id,ASC',
      filter: {
        agentId: '$eq',
        branchId: '$eq',
        dealerId: '$eq',
        approvalStatus: '$eq',
        paymentType: '$eq',
        createdTimestamp: 'between',
        createdBy: '$eq'
      }
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) startYear--;
        return {
          start: moment([startYear, startMonth, startDay]),
          end: moment([startYear + 1, startMonth, startDay]).subtract(1, 'days')
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) startYear--;
        return {
          start: moment([startYear - 1, startMonth, startDay]),
          end: moment([startYear, startMonth, startDay]).subtract(1, 'days')
        };
      }
    }];
    this.paymentMethods = [{
      label: 'Payment',
      key: 'Payment'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Sales Inwards',
      key: 'Sales Inwards'
    }];
  }
  async activated() {
    this.isAccountManager = AdminModule.roles.includes('Account Manager');
    this.isPaymentManager = isPaymentManager();
    this.isSuperAdmin = isSuperAdmin() || this.isPaymentManager;
    this.listQuery.isSuperAdmin = this.isSuperAdmin;
    this.loggedInAdmin = AdminModule;
    if (this.isPaymentManager) this.listQuery.paymentType = 'Payment';
    if (this.loggedInAdmin.id === 1) this.listQuery.paymentType = undefined;
    this.assignedBranches = await BranchAgentService.assignBranchId();
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    this.dateRange = this.$route.query.startDate && this.$route.query.endDate ? {
      start: this.$route.query.startDate,
      end: this.$route.query.endDate
    } : {
      start: this.$moment('2022-04-01').format('YYYY-MM-01 12:00') + ' am',
      end: this.$moment().endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
    };
    if (AdminModule.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = AdminModule.agentId;
    }
    await this.getAccountManagers();
    await this.getList();
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  handleSelectionChange(selectedLedgers) {
    this.selectedLedgerIds = selectedLedgers.map(ledger => ({
      ledger
    }));
  }
  async getAccountManagers() {
    try {
      const accountManagers = await getAccountManagers();
      this.accountManagerOptions = [{
        label: 'SUPER ADMIN',
        key: 1
      }, ...accountManagers.map(item => ({
        label: item.fullName,
        key: item.id
      }))];
      this.accountManagers = {
        1: 'SUPER ADMIN',
        ...accountManagers.reduce((acc, item) => {
          acc[item.id] = item.fullName;
          return acc;
        }, {})
      };
    } catch (error) {
      console.error(error);
      throw new Error('Failed to Fetch Account Managers');
    }
  }
  editNarration(row) {
    this.selectedRow = row;
    this.form.comments = row.comments;
    this.dialogFormVisible = true;
  }
  async saveNarration() {
    try {
      await updateNarration(this.selectedRow.id, {
        comments: this.form.comments
      });
      this.$message.success('Narration updated successfully');
      this.dialogFormVisible = false;
      this.selectedRow = null;
      this.getList();
    } catch (error) {
      this.$message.error('Error updating narration');
    }
  }
  async confirmAction(message, type, confirmButtonClass) {
    try {
      await this.$confirm(message, type, {
        confirmButtonText: 'Yes',
        confirmButtonClass,
        cancelButtonText: 'No',
        type: 'error'
      });
      return true;
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(`Error performing ${type.toLowerCase()}`);
      }
      return false;
    }
  }
  async handleLedgerAction(ids, action, type, showConfirmation = true) {
    try {
      if (showConfirmation) {
        const message = `Are you sure you want to ${action} ${ids.length > 1 ? 'these ledgers' : 'this ledger'}?`;
        const confirmClass = action === 'approve' ? 'el-button--success' : 'el-button--danger';
        if (!(await this.confirmAction(message, `${action} Ledger`, confirmClass))) {
          return;
        }
      }
      if (action === 'approve') {
        await approveLedger({
          ids
        });
      } else if (type === 'credit' || type === 'payment') {
        const ledgers = this.list.filter(ledger => ids.includes(ledger.id));
        if (ledgers.some(ledger => ledger.paymentType === 'Payment')) {
          await removedPaymentTypeLedgers({
            ids
          });
        } else {
          await removeCreditNoteItemWiseLedgers({
            ids
          });
        }
      } else {
        for (const id of ids) {
          await deleteLedger(id);
        }
      }
      if (showConfirmation) {
        this.$message.success(`Ledger${ids.length > 1 ? 's' : ''} ${action}d successfully`);
      }
      this.getList();
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(`Error ${action}ing ledger${ids.length > 1 ? 's' : ''}`);
      }
    }
  }
  async createEInvoice(id = 0) {
    try {
      this.listLoading = true;
      if (!(await this.confirmAction('Do you want to create E-invoice?', 'Create E-invoice', 'el-button--danger'))) {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
        return;
      }
      const response = await generateEInvoice(id);
      this.$message({
        message: (response === null || response === void 0 ? void 0 : response.status) === 'success' ? 'E-invoice created successfully' : 'Failed to create E-invoice',
        type: (response === null || response === void 0 ? void 0 : response.status) === 'success' ? 'success' : 'error'
      });
      this.getList();
    } catch (error) {
      this.$message.error('Error creating E-invoice');
    } finally {
      this.listLoading = false;
    }
  }
  async createInvoice(id = 0) {
    try {
      this.listLoading = true;
      if (!(await this.confirmAction('Do you want to create Invoice?', 'Create Invoice', 'el-button--danger'))) {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
        return;
      }
      const response = await generateInvoice(id);
      this.$message({
        message: (response === null || response === void 0 ? void 0 : response.status) === 'success' ? 'Invoice created successfully' : 'Failed to create Invoice',
        type: (response === null || response === void 0 ? void 0 : response.status) === 'success' ? 'success' : 'error'
      });
      this.getList();
    } catch (error) {
      this.$message.error('Error creating Invoice');
    } finally {
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end].join(',');
      } else this.listQuery.createdTimestamp = undefined;
      const data = await getPendingPaymentLedgerList(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.openingBalance = data.openingBalance;
      this.closingBalance = data.closingBalance;
    } catch (error) {
      this.$message.error('Error fetching ledger list');
    } finally {
      this.listLoading = false;
    }
  }
  async fetchBranches(superAdmin = true) {
    this.branchListLoading = true;
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    if (!superAdmin && this.listQuery.branchId.length === 0) {
      query.id = AdminModule.branchIds;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    this.branchList = await getBranches(getQuery(query));
    this.branchListLoading = false;
  }
  async getDealerList(query = null) {
    if (!query || (/^[0-9]+$/.test(query) ? query.length < 1 : query.length < 2)) {
      this.dealerList = [];
      return;
    }
    try {
      const searchParams = {
        keyword: query,
        searchBy: /^[0-9]+$/.test(query) ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: this.listQuery.branchId,
        agentId: this.listQuery.agentId
      };
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {}
  }
  async fetchAgentsBranch(branchId) {
    try {
      if (!branchId) branchId = AdminModule.branchIds;
      this.agentList = await getAgentsBranchWise(getQuery({
        enabled: true,
        sort: 'name,ASC',
        branchId
      }));
    } catch (error) {}
  }
  async getDealerById(dealerId = null) {
    this.dealerListLoading = true;
    try {
      const data = await getDealerById(dealerId);
      if (data) this.dealerList = [data];
    } finally {
      this.dealerListLoading = false;
    }
  }
  formatDate(timestamp) {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.paymentType === 'Sales Inwards') {
      this.listQuery.paymentType = 'Purchase,Credit Note Inward';
      this.listQuery.filter.paymentType = '$in';
    }
    if (this.listQuery.branchId) {
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
    }
    this.getList();
  }
  async handlePDFDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadPDF(cleanListQuery(this.listQuery));
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'ledger.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      this.$message.success('PDF downloaded successfully');
    } catch (error) {
      this.$message.error('Error downloading PDF');
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadExcel(cleanListQuery(this.listQuery));
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'ledgers.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      this.downloadLoading = false;
    }
  }
  async viewPdf(params, showMerged = false) {
    try {
      this.listLoading = true;
      let url;
      if (showMerged) {
        url = params.ledgerAttachmentS3Url;
      } else {
        url = params.paymentType === 'Credit Note' || params.paymentType === 'Debit Note' ? await viewCNDNInvoice(params.id) : await generateInvoice(params.id);
      }
      if (url) window.open(url, '_blank');else this.$message.error('Failed to generate invoice');
    } catch (error) {
      this.$message.error('Error generating invoice');
    } finally {
      this.listLoading = false;
    }
  }
  async approveSelectedLedgers() {
    if (!(await this.confirmAction(`Are you sure you want to approve ${this.selectedLedgerIds.length > 1 ? 'these ledgers' : 'this ledger'}?`, 'Approve Ledgers', 'el-button--success'))) {
      this.$message({
        type: 'info',
        message: 'Request cancelled'
      });
      return;
    }
    try {
      const ids = this.selectedLedgerIds.map(({
        ledger
      }) => ledger.id);
      await this.handleLedgerAction(ids, 'approve', 'credit', false);
      this.$message.success(`Ledger${ids.length > 1 ? 's' : ''} approved successfully`);
      this.getList();
    } catch (error) {
      this.$message.error(`Error approving ledger${this.selectedLedgerIds.length > 1 ? 's' : ''}`);
    }
  }
  async rejectSelectedLedgers() {
    if (!(await this.confirmAction(`Are you sure you want to reject ${this.selectedLedgerIds.length > 1 ? 'these ledgers' : 'this ledger'}?`, 'Reject Ledgers', 'el-button--success'))) {
      this.$message({
        type: 'info',
        message: 'Request cancelled'
      });
      return;
    }
    try {
      const ids = this.selectedLedgerIds.map(({
        ledger
      }) => ledger.id);
      await this.handleLedgerAction(ids, 'reject', 'credit', false);
      this.$message.success(`Ledger${ids.length > 1 ? 's' : ''} rejected successfully`);
      this.getList();
    } catch (error) {
      this.$message.error(`Error rejecting ledger${this.selectedLedgerIds.length > 1 ? 's' : ''}`);
    }
  }
  async fetchAllData() {
    try {
      const {
        page,
        limit,
        ...query
      } = cleanListQuery(this.listQuery);
      return await getPendingPaymentLedgerList(getQuery(query));
    } catch (error) {
      console.error('Error fetching all data:', error);
      return [];
    }
  }
  filterData(data, columns) {
    return data.map(item => {
      const filteredItem = {};
      columns.forEach(column => {
        const keys = column.split('.');
        let value = item;
        keys.forEach(key => value = value ? value[key] : null);
        filteredItem[column] = value;
      });
      return filteredItem;
    });
  }
  async exportToExcel() {
    try {
      const columnsToInclude = ['id', 'dealer.name', 'amount', 'paymentType', 'approvalStatus', 'comments', 'createdTimestamp'];
      const allData = await this.fetchAllData();
      const filteredData = this.filterData(allData, columnsToInclude);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(wb, ws, 'Pending Ledgers');
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([wbout], {
        type: 'application/octet-stream'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'approved_ledgers.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      this.$message.error('Error exporting to Excel');
    }
  }
};
default_1 = __decorate([Component({
  name: 'PendingPaymentLedgerList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;